<div
  class="first-row"
>
  <div
    class="app-image"
    [style.background-image]="imgSource"
  ></div>

  @if (tiles && template) {
    <div
      class="module-hvac"
    >
      @if (template.Modules.HVAC?.Zones[0].Temperature?.TileID || template.Modules.HVAC?.Zones[0].Humidity?.TileID) {
        <div>
          @if (template.Modules.HVAC?.Zones[0].Temperature?.TileID) {
            <motn-tile
              [elemSetup]="setUpHvacTemperatureTile(0)"
            ></motn-tile>
          }

          @if (template.Modules.HVAC?.Zones[0].Humidity?.TileID) {
            <motn-tile
              [elemSetup]="setUpHvacHumidityTile(0)"
            ></motn-tile>
          }
        </div>
      }

      @if (template.Modules.HVAC?.Zones[0].SetPointHeat?.TileID || template.Modules.HVAC?.Zones[0].SetPointCool?.TileID) {
        <div>
          @if (template.Modules.HVAC?.Zones[0].SetPointHeat?.TileID) {
            <motn-tile
              [elemSetup]="setUpHvacSetPointHeatTile(0)"
            ></motn-tile>
          }

          @if (template.Modules.HVAC?.Zones[0].SetPointCool?.TileID) {
            <motn-tile
              [elemSetup]="setUpHvacSetPointCoolTile(0)"
            ></motn-tile>
          }
        </div>
      }

      @if (template.Modules.HVAC?.Zones[0].SystemMode?.TileID || template.Modules.HVAC?.Zones[0].FanAlwaysOn?.TileID) {
        <div>
          @if (template.Modules.HVAC?.Zones[0].SystemMode?.TileID) {
            <motn-tile
              [elemSetup]="setUpHvacSystemModeTile(0)"
            ></motn-tile>
          }
          @if (template.Modules.HVAC?.Zones[0].FanAlwaysOn?.TileID) {
            <motn-tile
              [elemSetup]="setUpHvacFanAlwaysOnTile(0)"
            ></motn-tile>
          }
        </div>
      }

      @if (template.Modules.HVAC?.Zones[0].SetPoint?.TileID || template.Modules.HVAC?.Zones[0].OnOff?.TileID) {
        <div>
          @if (template.Modules.HVAC?.Zones[0].SetPoint?.TileID) {
            <motn-tile
              [elemSetup]="setUpHvacSetPointTile(0)"
            ></motn-tile>
          }

          @if (template.Modules.HVAC?.Zones[0].OnOff?.TileID) {
            <motn-tile
              [elemSetup]="setUpHvacOnOffTile(0)"
            ></motn-tile>
          }
        </div>
      }
    </div>
  }
</div>
